import { render, staticRenderFns } from "./Prmotion-Listing.vue?vue&type=template&id=3561cc9e&"
import script from "./Prmotion-Listing.vue?vue&type=script&lang=js&"
export * from "./Prmotion-Listing.vue?vue&type=script&lang=js&"
import style0 from "./Prmotion-Listing.vue?vue&type=style&index=0&id=3561cc9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports